/**
 * Zustand handle for language preference.
 *
 * Mirrors `useThemeStore`'s shape — pure helpers in `@/lib/language`,
 * Zustand wraps the persisted state. No DOM side effect today (i18n
 * isn't wired); when an i18n library lands it can subscribe to `lang`
 * here.
 */

import { create } from "zustand";
import {
  readStoredLanguage,
  resolveEffectiveLanguage,
  writeStoredLanguage,
  type LanguagePreference,
} from "@/lib/language";

interface LanguageState {
  /** Active language. Defaults to the stored value, then navigator-derived, then `pt-BR`. */
  lang: LanguagePreference;
  setLang: (lang: LanguagePreference) => void;
}

function bootLang(): LanguagePreference {
  const stored = readStoredLanguage();
  const navLang = typeof navigator !== "undefined" ? navigator.language : null;
  return resolveEffectiveLanguage(stored, navLang);
}

export const useLanguageStore = create<LanguageState>((set) => ({
  lang: bootLang(),
  setLang: (lang) => {
    writeStoredLanguage(lang);
    set({ lang });
  },
}));
